var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _vm.showErrorNotification
      ? _c("div", { staticClass: "center margin-vertical-20" }, [
          _c("div", { staticClass: "note note--error" }, [
            _c("p", [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.trans("SEARCH_GLOBALDATA_ERROR_TEXT")) +
                  "\n            "
              ),
            ]),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.showNoResultsNotification
      ? _c("div", { staticClass: "center margin-vertical-20" }, [
          _c("div", { staticClass: "note note--info" }, [
            _c("p", [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.trans("SEARCH_NO_RESULTS_TEXT")) +
                  "\n            "
              ),
            ]),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.loadingResults
      ? _c("div", { staticClass: "center" }, [
          _c("img", {
            staticClass: "margin-bottom-20",
            attrs: {
              src: _vm.getCdnLink("img/preloaders/preloader.gif"),
              width: "20",
              height: "20",
              alt: "",
            },
          }),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "list list--blank" },
      _vm._l(_vm.slicedItems, function (item) {
        return _c(
          "li",
          { key: item.ReportId, staticClass: "list__item pos-relative" },
          [
            _c(
              "div",
              {
                staticClass:
                  "list__itemWrap list__itemWrap--noHover text--linkReset padding-vertical-15",
              },
              [
                _c("i", { staticClass: "list__itemIcon float-left" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 26 26",
                        width: "26",
                        height: "26",
                      },
                    },
                    [_c("use", { attrs: { href: "#globalDataIcon" } })]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "list__itemText width70" }, [
                  _c(
                    "h2",
                    {
                      staticClass:
                        "h5 margin-bottom-0 text-ellipsis text-semibold",
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(item.Title) +
                          "\n                    "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("h3", { staticClass: "font-size-s text-ellipsis" }, [
                    _c("span", [_vm._v(_vm._s(item.ReportType))]),
                    _vm._v(
                      " | " +
                        _vm._s(item.Description) +
                        "\n                    "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "width25 buttonGroup display-flex flex--justifyContent-end",
                  },
                  [
                    item.ReportPdfFileName
                      ? _c(
                          "a",
                          {
                            staticClass: "button",
                            attrs: {
                              href: _vm.getLink(item.ReportPdfFileName),
                              target: "_blank",
                              referrerpolicy: "unsafe-url",
                              title: _vm.trans("DOWNLOAD_PDF_TEXT"),
                            },
                          },
                          [_c("span", { staticClass: "sprite fileIcon__pdf" })]
                        )
                      : _c("span", { staticClass: "button button--disabled" }, [
                          _c("span", {
                            staticClass: "sprite fileIcon__pdf--disabled",
                          }),
                        ]),
                    _vm._v(" "),
                    item.ReportXslFileName
                      ? _c(
                          "a",
                          {
                            staticClass: "button",
                            attrs: {
                              href: _vm.getLink(item.ReportXslFileName),
                              target: "_blank",
                              referrerpolicy: "unsafe-url",
                              title: _vm.trans("DOWNLOAD_XLS_TEXT"),
                            },
                          },
                          [_c("span", { staticClass: "sprite fileIcon__xls" })]
                        )
                      : _c("span", { staticClass: "button button--disabled" }, [
                          _c("span", {
                            staticClass: "sprite fileIcon__xls--disabled",
                          }),
                        ]),
                    _vm._v(" "),
                    item.ReportPptFileName
                      ? _c(
                          "a",
                          {
                            staticClass: "button",
                            attrs: {
                              href: _vm.getLink(item.ReportPptFileName),
                              target: "_blank",
                              referrerpolicy: "unsafe-url",
                              title: _vm.trans("DOWNLOAD_PPT_TEXT"),
                            },
                          },
                          [_c("span", { staticClass: "sprite fileIcon__ppt" })]
                        )
                      : _c("span", { staticClass: "button button--disabled" }, [
                          _c("span", {
                            staticClass: "sprite fileIcon__ppt--disabled",
                          }),
                        ]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "button",
                        attrs: {
                          href: _vm.getLink(
                            _vm.detailViewPrefix + item.UrlNode
                          ),
                          target: "_blank",
                          referrerpolicy: "unsafe-url",
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-globe",
                          attrs: { "aria-hidden": "true" },
                        }),
                      ]
                    ),
                  ]
                ),
              ]
            ),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }